import React from 'react';
import { Markdown } from '../../../../../../components/Markdown';
export const DailyWagArticleContentContainer = ({
  value
}) => <Markdown version="react-markdown" data-sentry-element="Markdown" data-sentry-component="DailyWagArticleContentContainer" data-sentry-source-file="index.tsx">
    {value}
  </Markdown>;